"use strict";

exports.__esModule = true;
exports.authRequestSuccess = exports.authRequestError = exports.authRequest = exports.authRefreshSuccess = void 0;
var _constants = require("./constants");
var authRequest = exports.authRequest = function authRequest() {
  return {
    type: _constants.AUTH_REQUEST_ACTION_TYPE
  };
};
var authRefreshSuccess = exports.authRefreshSuccess = function authRefreshSuccess(payload) {
  return {
    type: _constants.AUTH_REFRESH_SUCCESS_ACTION_TYPE,
    payload: payload
  };
};
var authRequestSuccess = exports.authRequestSuccess = function authRequestSuccess(payload) {
  return {
    type: _constants.AUTH_REQUEST_SUCCESS_ACTION_TYPE,
    payload: payload
  };
};
var authRequestError = exports.authRequestError = function authRequestError(payload) {
  return {
    type: _constants.AUTH_REQUEST_ERROR_ACTION_TYPE,
    payload: payload
  };
};